export default {"src":"/parent/_next/static/media/nest-logo.1324b116.svg","height":139,"width":144,"blurWidth":0,"blurHeight":0};